module.exports = __webpack_public_path__ + "static/poster-5011c6d89b16749cb6d85781e7b4ae06.png";